const DEFAULT_COLUMN_WIDTH = 150;
const MIN_COLUMN_WIDTH = 56;
const CELL_HORIZONTAL_EXTRAS = 25;
const MEASURE_ROW_LIMIT = 1000;

let sharedContext: CanvasRenderingContext2D | null | undefined;

const getMeasureContext = (): CanvasRenderingContext2D | null => {
  if (sharedContext === undefined) {
    sharedContext =
      typeof document === 'undefined'
        ? null
        : document.createElement('canvas').getContext('2d');
  }
  return sharedContext;
};

/**
 * Width for a discovery-table column: the smaller of the 150px default and the
 * widest cell CONTENT. The header label is deliberately excluded — columns fit
 * their data and long headers ellipsize (matches Figma v1.1). Returns undefined
 * where canvas text metrics are unavailable (jsdom) so callers fall back to the
 * default width.
 */
export const measureDiscoveryColumnWidth = ({
  rows,
  columnKey,
  formatCellText,
}: {
  rows: Record<string, unknown>[];
  columnKey: string;
  formatCellText: (value: unknown) => string;
}): number | undefined => {
  const context = getMeasureContext();
  if (!context) return undefined;

  const fontFamily =
    window.getComputedStyle(document.body).fontFamily || 'sans-serif';
  context.font = `400 14px ${fontFamily}`;

  let widest = 0;
  const rowLimit = Math.min(rows.length, MEASURE_ROW_LIMIT);
  for (let index = 0; index < rowLimit; index += 1) {
    if (widest + CELL_HORIZONTAL_EXTRAS >= DEFAULT_COLUMN_WIDTH) break;
    const width = context.measureText(
      formatCellText(rows[index]?.[columnKey])
    ).width;
    if (width > widest) widest = width;
  }

  return Math.max(
    MIN_COLUMN_WIDTH,
    Math.min(DEFAULT_COLUMN_WIDTH, Math.ceil(widest + CELL_HORIZONTAL_EXTRAS))
  );
};
